var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63901 13.8316C7.98801 14.8806 8.65001 14.9176 9.11701 13.9176L14.426 2.54261C14.893 1.54061 14.46 1.10861 13.459 1.57561L2.08301 6.88361C1.08201 7.35061 1.12001 8.01261 2.16801 8.36261L6.27101 9.72961L7.63901 13.8316Z",
    stroke: "#333333",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.aa9dc7a8c3e76a93c6b8a119a09803ea.svg";
export { ForwardRef as ReactComponent };